import { default as merge } from "./merge";
import { default as utils } from "./utils";
import { default as theme } from "./theme";
import { default as field } from "./field";
import { default as array } from "./array";
import { default as validate } from "./validate";
import { default as make } from "./make";
import { default as temp } from "./temp";
import { default as data } from "./data";
import { default as resetkey } from "./resetkey";
export const hocs = [merge, utils, theme, field, array, validate, make, temp, data, resetkey];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/fx-schema-form-react/libs/hocs/index.js
// module id = 269
// module chunks = 3